import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Modal, CardBody} from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaEraser, FaTrash } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, getCurrentUser, formataDataHoraExibicao } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';

class AtendimentosHiPlatformParaAtendimento extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaHiPlatform = this.buscaHiPlatform.bind(this);
        this.limpaFiltro = this.limpaFiltro.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            filtro_programa_id: '',
            filtro_programa_nome: '',
            telefone: "",
            data_inicio_atendimento: "",
            data_fim_atendimento: "",
            page_numb: 1,
            loading: true,
            atendimento_id: null,
            carregamentoAbas: [],
            mensagens: [],
            loadingMensagens: false,
            // Campos do atendimento HiPlatform
            showModalHiPlatform: false,
            protocolo: "",
            canal: "",
            operador: "",
            fila_entrada: "",
            fila_atual: "",
            departamento: "",
            data_entrada: "",                
            tempo_fila: "",
            tempo_operador: "",
            tempo_total: "",
            estado: "",
            detalhe_esperado: "",
            origem: "",
            grupo: "",
            propriedade: "",
            valor_propriedade: 0,
            classificacao: "",
            pergunta: "",
            resposta: "",
            pesquisa: "",
            resposta_pesquisa: "",
            detail_data_sinc: "",  
        };
    }

    componentDidMount() {
        const { atendimento_id, programa_id, beneficiario_dados } = this.props;

        let telefone = '';
        if (beneficiario_dados) {
            telefone = beneficiario_dados.telefone || beneficiario_dados.celular || '';
            telefone = telefone.replace(/\D/g, ''); 
        }

        this.setState({
            atendimento_id,
            filtro_programa_id: programa_id,
            telefone
        }, () => {
            this.consultaAtendimentosHi(1);
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimento_id !== this.props.atendimento_id || 
            prevProps.programa_id !== this.props.programa_id || 
            prevProps.beneficiario_dados !== this.props.beneficiario_dados) {

            const telefone = this.props.beneficiario_dados?.telefone || this.props.beneficiario_dados?.celular || '';

            this.setState({
                atendimento_id: this.props.atendimento_id,
                filtro_programa_id: this.props.programa_id,
                telefone
            }, () => {
                this.consultaAtendimentosHi(1);
            });
        }
    }

        consultaAtendimentosHi(page_numb = 1) {
            const { telefone} = this.state;

            if (!telefone || telefone.trim() === '') {
                this.setState({
                    loading: false,
                    listRegistros: [],
                    error: 'Paciente sem número para consultar histórico da HiPlatform'
                });
                return;
            }

            let dados_usuario = getCurrentUser();

            let url = `/hiplatform/atendimentos/?page=${page_numb}&atendimento_id=${this.state.atendimento_id}`;

            if (this.state.filtro_programa_id) {
                url += `&programa_id=${this.state.filtro_programa_id}`;
            }

            if (this.state.telefone) {
                url += `&telefone=${this.state.telefone}`;
            }

            if (this.state.data_inicio_atendimento) {
                url += `&data_inicio=${this.state.data_inicio_atendimento}`;
            }

            if (this.state.data_fim_atendimento) {
                url += `&data_fim=${this.state.data_fim_atendimento}`;
            }

            this.setState({ loading: true });

            api.get(url)
                .then(response => {
                    this.setState({
                        loading: false,
                        error: "",
                        listRegistros: response.data,
                        page_numb
                    });
                })
                
                .catch(error => {
                    let erro_msg = 'Erro ao consultar Atendimento HiPlatform, tente novamente.';

                    if (error.response?.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    } else if (error.response?.status === 403) {
                        erro_msg = 'Você não tem permissão para acessar essa área';
                    }

                    this.setState({
                        loading: false,
                        error: erro_msg
                    });
                });
                    console.log('[HiPlatform] URL da consulta:', url);

        }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.protocolo}</td>
                <td>{item.canal}</td>
                <td>{item.operador}</td>
                <td>{item.data_inicio_atendimento}</td>
                <td>{item.data_fim_atendimento}</td>
                <td>{item.departamento}</td>
                <td>{item.estado}</td>
                <td className="text-end">
                    <Button variant="light" onClick={() => this.carregarHiPlatform(item.id)} size="sm">
                        <FaRegEdit /> Visualizar
                    </Button>
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={3}>Nenhum atendimento hiplatform encontrado</td>
            </tr>
        );
    };

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                filtro_prestador_id: "", 
                filtro_prestador_nome: "", 
                prestador_select_key: prevState.prestador_select_key + 1 
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaAtendimentosHi(num_page)
    };
    
    buscaHiPlatform(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaAtendimentosHi(this.state.busca)
    };

    limpaFiltro() {
        let startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        let endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

        this.setState({
            data_inicio_atendimento: startOfMonth,
            data_fim_atendimento: endOfMonth,
        }, () => {
            this.consultaAtendimentosHi();
        });
    }

    carregarHiPlatform(id) {
        let dados_usuario = getCurrentUser();

        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario,
            loading: false,
            erroLoadRegistro: ''
        });

        if (id) {
            this.setState({
                id: id,
                titulo_pagina: 'Atendimento HiPlatform',
                loading: true,
                erroLoadRegistro: ''
            });

            api.get(`/hiplatform/atendimentos/${id}/`)
                .then(response => {
                    const dados = response.data;

                    this.setState({
                        showModalHiPlatform: true,

                        loading: false,
                        erroLoadRegistro: '',
                        id: dados.id,
                        protocolo: dados.protocolo,
                        canal: dados.canal,
                        operador: dados.operador,
                        fila_entrada: dados.fila_entrada,
                        fila_atual: dados.fila_atual,
                        departamento: dados.departamento,
                        data_entrada: dados.data_entrada,
                        data_inicio_atendimento: dados.data_inicio_atendimento,
                        data_fim_atendimento: dados.data_fim_atendimento,
                        tempo_fila: dados.tempo_fila,
                        tempo_operador: dados.tempo_operador,
                        tempo_total: dados.tempo_total,
                        estado: dados.estado,
                        detalhe_esperado: dados.detalhe_esperado,
                        origem: dados.origem,
                        grupo: dados.grupo,
                        propriedade: dados.propriedade,
                        valor_propriedade: dados.valor_propriedade,
                        classificacao: dados.classificacao,
                        pergunta: dados.pergunta,
                        resposta: dados.resposta,
                        pesquisa: dados.pesquisa,
                        resposta_pesquisa: dados.resposta_pesquisa,
                        detail_data_sinc: dados.detail_data_sinc,
                        telefone: dados.telefone,
                    });
                        this.carregarMensagensAtendimento(id);
                })
                .catch(error => {
                    let erro_msg = 'Erro ao consultar o atendimento, tente novamente';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        loading: false,
                        erroLoadRegistro: erro_msg,
                    });
                });
        }
    }

    handleCloseModalHiPlatform = () => {
        this.setState({ 
            showModalHiPlatform: false,
            protocolo: "",
            canal: "",
            operador: "",
            fila_entrada: "",
            fila_atual: "",
            departamento: "",
            data_entrada: "",                
            tempo_fila: "",
            tempo_operador: "",
            tempo_total: "",
            estado: "",
            detalhe_esperado: "",
            origem: "",
            grupo: "",
            propriedade: "",
            valor_propriedade: 0,
            classificacao: "",
            pergunta: "",
            resposta: "",
            pesquisa: "",
            resposta_pesquisa: "",
            detail_data_sinc: "",  
            telefone: "",  
            data_inicio_atendimento: "",  
            data_fim_atendimento: "",  
        });
    };

    
    carregarMensagensAtendimento = (atendimento_id) => {
        if (!atendimento_id) return;

        this.setState({ loadingMensagens: true });

        api.get(`/hiplatform/atendimentos/mensagens/?atendimento_id=${atendimento_id}`)
            .then(response => {

                const mensagens = Array.isArray(response.data.results) ? response.data.results : [];

                this.setState({
                    mensagens: mensagens,
                    loadingMensagens: false
                });
            })
            .catch(error => {
                console.error('Erro ao carregar mensagens:', error);
                this.setState({ loadingMensagens: false, mensagens: [] });
            });
    }

    render() {
        if (!hasPerm('view_atendimentos_hi_platform')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Card className="cardDestaque">
                    <Card.Body>  
                        <Row>
                            <Col sm={6} lg={6}>
                                <h6><strong>Atendimentos HiPlatform</strong></h6>
                            </Col>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaHiPlatform}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Data Início</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="data_inicio_atendimento"
                                                                value={this.state.data_inicio_atendimento}
                                                                onChange={e => this.handleChangeFiltros(e, 'data_inicio_atendimento')}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                {this.state.data_inicio_atendimento && (
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Data Fim</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="data_fim_atendimento"
                                                                value={this.state.data_fim_atendimento}
                                                                onChange={e => this.handleChangeFiltros(e, 'data_fim_atendimento')}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                )} 
                                                </Row>

                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>

                                                <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row> 

                        {/* Modal listagem HiPlatform */}
                        <Modal size="xl" show={this.state.showModalHiPlatform} onHide={this.handleCloseModalHiPlatform}>
                            <Modal.Header closeButton>
                                <Modal.Title>Atendimento HiPlatform</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Card>
                                    <Form onSubmit="">
                                        <CardBody>
                                            <Row>  
                                                <Col sm={6} xs={12}>
                                                    <label>ID: </label>
                                                    <span>
                                                        {this.state.id}
                                                    </span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Protocolo: </label>
                                                    <span> {this.state.protocolo}</span>
                                                </Col>                          
                                                <Col sm={6} xs={12}>
                                                    <label>Canal: </label>
                                                    <span> {this.state.canal}</span>
                                                </Col>                          
                                                <Col sm={6} xs={12}>
                                                    <label>Operador: </label>
                                                    <span> {this.state.operador}</span>
                                                </Col>                          
                                                <Col sm={6} xs={12}>
                                                    <label>Fila Entrada: </label>
                                                    <span> {this.state.fila_entrada}</span>
                                                </Col>                          
                                                <Col sm={6} xs={12}>
                                                    <label>Fila Atual: </label>
                                                    <span> {this.state.fila_atual}</span>
                                                </Col>                          
                                                <Col sm={6} xs={12}>
                                                    <label>Departamento: </label>
                                                    <span> {this.state.departamento}</span>
                                                </Col>                          
                                                <Col sm={6} xs={12}>
                                                    <label>Data da Entrada: </label>
                                                    <span> {formataDataHoraExibicao(this.state.data_entrada)}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Data de início: </label>
                                                    <span> {formataDataHoraExibicao(this.state.data_inicio_atendimento)}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Data final: </label>
                                                    <span> {formataDataHoraExibicao(this.state.data_fim_atendimento)}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Tempo na Fila: </label>
                                                    <span>{this.state.tempo_fila}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Tempo Operador: </label>
                                                    <span>{this.state.tempo_operador}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Tempo Total: </label>
                                                    <span>{this.state.tempo_total}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Estado: </label>
                                                    <span>{this.state.estado}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Detalhe Esperado: </label>
                                                    <span>{this.state.detalhe_esperado}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Origem: </label>
                                                    <span>{this.state.origem}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Grupo: </label>
                                                    <span>{this.state.grupo}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Propriedade: </label>
                                                    <span>{this.state.propriedade}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Valor Propriedade: </label>
                                                    <span> {parseFloat(this.state.valor_propriedade).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Classificação: </label>
                                                    <span>{this.state.classificacao}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Pergunta: </label>
                                                    <span>{this.state.pergunta}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Resposta: </label>
                                                    <span>{this.state.resposta}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Pesquisa: </label>
                                                    <span>{this.state.pesquisa}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Resposta da Pesquisa: </label>
                                                    <span>{this.state.resposta_pesquisa}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Data de Sincronização: </label>
                                                    <span>{formataDataHoraExibicao(this.state.detail_data_sinc)}</span>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <label>Telefone: </label>
                                                    <span>{this.state.telefone}</span>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                        
                                        <CardBody>
                                            <Row>
                                                <h4>Troca de Mensagens do Atendimento</h4>
                                                    {this.state.loadingMensagens ? (
                                                        <p>Carregando mensagens...</p>
                                                    ) : !Array.isArray(this.state.mensagens) || this.state.mensagens.length === 0 ? (
                                                        <p>Sem mensagens registradas.</p>
                                                    ) : (
                                                        <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px', borderRadius: '5px' }}>
                                                            {this.state.mensagens.map((msg) => (
                                                                <div key={msg.id} style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '5px' }}>
                                                                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{msg.remetente}</div>
                                                                    <div style={{ whiteSpace: 'pre-wrap', marginBottom: '5px' }}>{msg.mensagem}</div>
                                                                    <div style={{ fontSize: '0.8em', color: '#666' }}>{formataDataHoraExibicao(msg.data)}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                )}
                                            </Row>
                                        </CardBody>
                                    </Form> 
                                </Card>

                            </Modal.Body>
                        </Modal> 

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Protocolo</th>
                                    <th>Canal</th>
                                    <th>Operador</th>
                                    <th>Data Início</th>
                                    <th>Data Fim</th>
                                    <th>Departamento</th>
                                    <th>Estado</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={3}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={3}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(AtendimentosHiPlatformParaAtendimento);